import {useMemo} from "react";

export enum ValidCountries {
    MACEDONIA = "Macedonia"
}

const useCitiesByCountry = (countryName: ValidCountries) => {
    const cities = useMemo(() => {
        if (countryName === ValidCountries.MACEDONIA) {
            return {
                "Berovo": {"mk": "Берово", "en": "Berovo", "al": "Berovë"},
                "Bitola": {"mk": "Битола", "en": "Bitola", "al": "Manastir"},
                "Debar": {"mk": "Дебар", "en": "Debar", "al": "Dibër"},
                "Delchevo": {"mk": "Делчево", "en": "Delchevo", "al": "Dellçevë"},
                "Demir Hisar": {"mk": "Демир Хисар", "en": "Demir Hisar", "al": "Demir Hisar"},
                "Gevgelija": {"mk": "Гевгелија", "en": "Gevgelija", "al": "Gjevgjeli"},
                "Gostivar": {"mk": "Гостивар", "en": "Gostivar", "al": "Gostivar"},
                "Kavadarci": {"mk": "Кавадарци", "en": "Kavadarci", "al": "Kavadarci"},
                "Kichevo": {"mk": "Кичево", "en": "Kichevo", "al": "Kërçovë"},
                "Kochani": {"mk": "Кочани", "en": "Kochani", "al": "Koçani"},
                "Kratovo": {"mk": "Кратово", "en": "Kratovo", "al": "Kratovë"},
                "Kriva Palanka": {"mk": "Крива Паланка", "en": "Kriva Palanka", "al": "Kriva Pallankë"},
                "Krushevo": {"mk": "Крушево", "en": "Krushevo", "al": "Krushevë"},
                "Kumanovo": {"mk": "Куманово", "en": "Kumanovo", "al": "Kumanovë"},
                "Makedonski Brod": {"mk": "Македонски Брод", "en": "Makedonski Brod", "al": "Brod"},
                "Negotino": {"mk": "Неготино", "en": "Negotino", "al": "Negotinë"},
                "Ohrid": {"mk": "Охрид", "en": "Ohrid", "al": "Ohër"},
                "Prilep": {"mk": "Прилеп", "en": "Prilep", "al": "Prilep"},
                "Probishtip": {"mk": "Пробиштип", "en": "Probishtip", "al": "Probishtip"},
                "Radovish": {"mk": "Радовиш", "en": "Radovish", "al": "Radovish"},
                "Resen": {"mk": "Ресен", "en": "Resen", "al": "Resnjë"},
                "Shtip": {"mk": "Штип", "en": "Shtip", "al": "Shtip"},
                "Skopje": {"mk": "Скопје", "en": "Skopje", "al": "Shkup"},
                "Struga": {"mk": "Струга", "en": "Struga", "al": "Strugë"},
                "Strumica": {"mk": "Струмица", "en": "Strumica", "al": "Strumicë"},
                "Sveti Nikole": {"mk": "Свети Николе", "en": "Sveti Nikole", "al": "Sveti Nikole"},
                "Tetovo": {"mk": "Тетово", "en": "Tetovo", "al": "Tetovë"},
                "Valandovo": {"mk": "Валандово", "en": "Valandovo", "al": "Valandovë"},
                "Veles": {"mk": "Велес", "en": "Veles", "al": "Veles"},
                "Vinica": {"mk": "Виница", "en": "Vinica", "al": "Vinicë"},
            }
        }
        return []
    }, [countryName])


    return {cities}
}

export default useCitiesByCountry
